import { Component, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { Lessee, LesseeProviders } from '../../../../../_models';
import { LesseeFormComponent, Type } from '../lessee-form';
import { DatePickerComponent } from '../../../../../shared/date-picker';

@Component({
    selector: 'app-lessee-edit',
    templateUrl: '../lessee-form/lessee-form.component.html',
    providers: [LesseeProviders]
})
export class LesseeEditComponent extends LesseeFormComponent {
    @ViewChild(DatePickerComponent) date: DatePickerComponent;
    id: number;
    constructor(private lesseeDataNew: Lessee, private fbNew: FormBuilder,
        private _locationNew: Location, private _routerNew: Router,
        private _route: ActivatedRoute) {
        super(lesseeDataNew, fbNew, _locationNew, _routerNew);
        this.id = this._route.snapshot.params['id'];
        this.lesseeData.get(this.id).subscribe(lessee => {
            this.form.setValue(lessee.pick(this.form.value));
            this.date.setDate(lessee.dob);
            let id = (lessee.type == 'Moral') ? 1 : 0;
            this.type = new Type({ id: id, value: lessee.type });
        })
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid) this.requests$ =
                this.lesseeData.put(this.id, formValue);
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/lessees/lessee-edit/lessee-edit.component.ts